export type TelegramWebApp = {
  initData: string;
  ready(): void;
  expand(): void;
  close(): void;
  BackButton?: {
    show(): void;
    hide(): void;
    onClick(callback: () => void): void;
    offClick(callback: () => void): void;
  };
  HapticFeedback?: {
    impactOccurred(style: "light" | "medium" | "heavy"): void;
    notificationOccurred(type: "error" | "success" | "warning"): void;
  };
};
declare global {
  interface Window {
    Telegram?: { WebApp?: TelegramWebApp };
  }
}
export function initializeTelegram(): TelegramWebApp | null {
  const app = window.Telegram?.WebApp ?? null;
  app?.ready();
  app?.expand();
  return app;
}
export function haptic(type: "like" | "pass" | "success"): void {
  const feedback = window.Telegram?.WebApp?.HapticFeedback;
  if (!feedback) return;
  if (type === "success") feedback.notificationOccurred("success");
  else feedback.impactOccurred(type === "like" ? "medium" : "light");
}
